import React from "react";
import { PATH } from "../../router/constants/Path";
import { useSelector } from "react-redux";
import State from "../../state/vo/State";
import "consignment-stock/css/index.css";
import { skipToken } from "@reduxjs/toolkit/query";
import { useContractsQuery } from "../services/contractApi";
import ContractsContent from "./ContractsContent";
import { useLang } from "../../router/hooks/useLang";
import Layout from "../../layout/components/Layout";
import Header from "../../layout/components/Header";
import MobileMenu from "../../layout/components/MobileMenu";
import SearchOverlay from "../../search/components/SearchOverlay";
import Body from "../../layout/components/Body";
import Middle from "../../layout/components/Col/Middle";
import LoadingText from "../../layout/components/LoadingText";
import Right from "../../layout/components/Col/Right";
import CartOverlay from "../../cart/components/CartOverlay";
import Footer from "../../layout/components/Footer";
import Navigation from "./Navigation";
import useInitCustomer from "../hooks/useInitCustomer";
import { AccountFallback } from "./AccountFallback";
import useCustomerId from "../hooks/useCustomerId";
import Error from "./Error";

const Contracts: React.FC = () => {
  const language = useLang();
  useInitCustomer();

  const accountCustomer = useSelector((state: State) => state.account.customer);
  const customerId = useCustomerId();

  const {
    data: contracts,
    isFetching,
    error,
  } = useContractsQuery(customerId && language ? { customerId, language } : skipToken, {
    refetchOnMountOrArgChange: true,
  });

  if (accountCustomer === null) {
    return <AccountFallback />;
  }

  return (
    <Layout>
      <Header />
      <MobileMenu />
      <SearchOverlay />
      <Body>
        <Navigation path={PATH.CONTRACTS} />
        <Middle>
          {isFetching && !error && <LoadingText />}
          {error && <Error error={error} />}
          {contracts?.debitorQuantityContracts ? (
            <ContractsContent debitorQuantityContracts={contracts.debitorQuantityContracts} />
          ) : null}
        </Middle>
        <Right removeOnCartClosed={true}>
          <CartOverlay />
        </Right>
      </Body>
      <Footer />
    </Layout>
  );
};

export default Contracts;
